import type { Session, User } from '@supabase/supabase-js';
import { create } from 'zustand';

import { supabase } from '../config/supabase';

interface AuthState {
  loading: boolean;
  session: Session | null;
  user: User | null;
  error: string | null;
  signIn: (email: string, password: string) => Promise<void>;
  signOut: () => Promise<void>;
  initFromSession: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set) => ({
  loading: true,
  session: null,
  user: null,
  error: null,

  async signIn(email, password) {
    set({ loading: true, error: null });
    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });
    if (error) {
      set({ error: error.message, loading: false });
      throw error;
    }
    set({
      session: data.session,
      user: data.user,
      loading: false,
      error: null,
    });
  },

  async signOut() {
    await supabase.auth.signOut();
    set({ session: null, user: null });
  },

  async initFromSession() {
    set({ loading: true });
    const { data } = await supabase.auth.getSession();
    set({
      session: data.session ?? null,
      user: data.session?.user ?? null,
      loading: false,
    });
    supabase.auth.onAuthStateChange((_event, session) => {
      set({
        session: session ?? null,
        user: session?.user ?? null,
      });
    });
  },
}));
